import { Dictionary, isObject, values } from "lodash"

import isStringArray from "./isStringArray"

export default function isStringArrayDictionary(
  value: unknown
): value is Dictionary<string[]> {
  return isObject(value) && values(value).every(isStringArray)
}
